module.exports = __webpack_public_path__ + "static/Fundcount-9d4d8170643cdd29081b74baf0ad7e0e.png";